<template xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div>
		<b-tooltip
			:disabled="helpState === false"
			target="choose-video-button"
		>
			{{ $t("Tooltip.import_message") }}
		</b-tooltip>
		<b-tooltip
			:disabled="helpState === false"
			target="capture-video-button"
		>

		</b-tooltip>
		<b-tooltip
			:disabled="helpState === false"
			target="cut-video-button"
		>
			{{ $t("Tooltip.cut_message") }}
		</b-tooltip>
		<b-tooltip
			:disabled="helpState === false"
			target="add-subtitles-video-button"
		>
			{{ $t("Tooltip.subtitle_import") }}
		</b-tooltip>

		<b-modal
			ref="loaderModal"
			hide-footer
			title="Chargement..."
		>
			<throbber />
			<p class="my-4">{{ $t("Tooltip.message_wait") }}</p>
		</b-modal>

		<b-modal
			ref="uploadModal"
			hide-footer
			title="Chargement..."
		>
			<throbber />
			<progressbar :value="upload_progress_value" :max="upload_progress_total" />
			<p>Chargement de la vidéo {{ upload_progress_value }} sur {{ upload_progress_total }}.</p>
		</b-modal>

		<b-modal
			:size="'lg'"
			ref="previewModal"
			static="true"
			:lazy="true"
			ok-only
		>
			<div class="embed-responsive embed-responsive-16by9">
				<video
					class="embed-responsive-item"
					:src="preview_path"
					ref="playerpreview"
					controls
					height="600"
					width="800"
				></video>
			</div>
		</b-modal>

		<b-modal
			:size="'lg'"
			ref="clipModal"
			static="true"
			:lazy="true"
			ok-only
		>
			<div class="embed-responsive embed-responsive-16by9">
				<video
					class="embed-responsive-item"
					:src="clip_path"
					ref="playerclip"
					controls
					height="600"
					width="800"
				></video>
			</div>
		</b-modal>

		<b-modal
			:size="'lg'"
			ref="baseModal"
			static="true"
			:lazy="true"
			ok-only
		>
			<div class="embed-responsive embed-responsive-16by9">
				<video
					class="embed-responsive-item"
					:src="base_path"
					ref="playerclip"
					controls
					height="600"
					width="800"
				></video>
			</div>
		</b-modal>

		<b-modal
			ref="modalError"
			hide-footer
			title="Erreur"
		>
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<b-modal
			ref="loaderSubtitleModal"
			hide-footer
			title="Chargement..."
		>
			<throbber />
			<p class="my-4">{{ $t("Button.syncsubs_message2") }}</p>
		</b-modal>

		<div v-if="step_mode === 0">
			<div class="video-list">
				<div v-for="(item, index) in this.videos" :key="index" class="video-block">
					<div class="video-thumbnail" :style="{'background-image': 'url(' + base_url + '/public/storage/images/' + item[1] + ')'}">
						<button class="play-overlay" @click="play_clip(item[0])">
							<div>▶&#xFE0E;</div>
						</button>
						<button :disabled="modified" v-if="index !== 0" class="left" @click="move(index, -1)">⭠&#xFE0E;</button>
						<button :disabled="modified" v-if="index !== videos.length - 1" class="right" @click="move(index, 1)">⭢&#xFE0E;</button>
					</div>
					<div class="menu">
						<button class="btn btn-edition" @click="cut_video(item[0])">Découper</button>
						<button class="btn btn-reinitialization" @click="del_video(item[0], index)">Supprimer</button>
					</div>
				</div>
			</div>

			<div class="button-bar">
				<label
					class="btn btn-edition"
					id="choose-video-button"
					v-if="!modified"
				>{{ $t("Button.import") }} <input
					type="file"
					id="input_newfile"
					ref="fileUpload"
					accept="video/mp4, video/quicktime"
					@change="upload_files"
					multiple
					hidden
					:disabled="modified"
				></label>

				<b-col v-if="false">
					<a id="capture-video-button" class="btn btn-edition" :href="'enjoyb:' + this.capture_ident">Capturer mon écran</a>
				</b-col>

				<button
					class="btn btn-validation"
					@click="validate_video_selection"
					v-if="this.videos.length > 0"
				>Valider ma sélection vidéo
				</button>
			</div>
		</div>

		<div v-if="step_mode === 1">
			<div id="editor_grid">
				<div class="video-info">
					<div class="video-thumbnail"
						:style="{'background-image': 'url(' + base_url + '/public/storage/images/' + videos[0][1] + ')'}"
					>
						<button class="play-overlay" @click="play_base">
							<div>▶&#xFE0E;</div>
						</button>
					</div>
					<div class="video-controls">

					</div>
				</div>

				<div class="edit-buttons"> <!-- edit button row -->

					<button class="btn btn-return" @click="back_mode">Éditer la sélection vidéo</button>

					<button class="btn btn-cut btn-edition"
						v-if="videos.length > 0"
						@click="goToCut"
						:disabled="modified"
						id="cut-video-button">{{ $t('Button.cut') }}
					</button>
					<button v-if="!hasSubtitles && ready_for_edit"
						class="btn btn-info"
						id="add-subtitles-video-button"
						:disabled="modified"
						@click.prevent="goToEdition"
					>{{ $t("Button.add_subtitles") }}
					</button>
					<button v-if="hasSubtitles"
						:disabled="modified"
						class="btn btn-insert-voice"
						@click.prevent="goToEdition"
					>{{ $t("Button.edit_subtitles") }}
					</button>
				</div>
				<div class="inputs">
					<div class="form-group" v-if="hasTitleField">
						<label class="title_label" for="title">{{ $t("Speech.title") }}</label> <input
						type="text"
						class="form-control no-border"
						:class="[ inputValueTitle.length >= 100 ? 'warning' : '' ]"
						id="title"
						@change="setModified"
						@input="setModified"
						v-model="inputValueTitle"
					>
					</div>

					<div class="form-group" v-if="hasSecondaryTitleField">
						<label class="subtitle_label" for="subtitle">{{ $t("Speech.secondary_title") }}</label> <input
						type="text"
						class="form-control no-border"
						:class="[ inputValueSecondaryTitle.length >= 100 ? 'warning' : '' ]"
						@change="setModified"
						@input="setModified"
						id="subtitle"
						v-model="inputValueSecondaryTitle">
					</div>

					<div class="form-group" v-if="hasKeywordsField">
						<label class="function_label" for="keywords">{{ $t("Speech.keywords") }}</label> <input
						type="text"
						class="form-control no-border"
						id="keywords"
						@change="setModified"
						@input="setModified"
						v-model="inputValueKeywords"
					>
					</div>

				</div>
				<div class="audio"> <!-- audio inputs -->

					<div class="form-group">
						<label><input type="checkbox" name="mute" v-model="isMuted"
							@change="setModified" /> {{ $t("Button.mute") }}</label> <label>Volume : {{ volume }}%<br /><input :disabled="isMuted" @change="setModified" type="range" id="volume" name="volume"
						min="10" max="200" step="10" v-model="volume"></label>
					</div>
					<div class="form-group">
						<label><input type="checkbox" name="mute" v-model="hasMusicEnable"
							@change="setModified" /> {{ $t("Button.enable_music") }}</label>
						<label>Volume : {{ music_volume }}%<br /><input :disabled="!hasMusicEnable" @change="setModified" type="range" id="music_volume" name="music_volume"
							min="10" max="100" step="10" v-model="music_volume"></label>
					</div>
				</div>
				<div class="valid-buttons">

					<ValidStep
						:valueKeywords="inputValueKeywords"
						:valueName="inputValueTitle"
						:muted="isMuted"
						:music_enabled="hasMusicEnable"
						:volume="volume"
						:music_volume="music_volume"
						:modal="$refs.loaderModal"
						:valueFunction="inputValueSecondaryTitle"
						:id="this.id"
						:stepOrder="stepIndex"
						:disabled="!(modified)"
					/>

					<button
						class="btn btn-preview"
						:disabled="!isCompleted || modified"
						@click="preview"
					>{{ $t("Button.preview") }}
					</button>

					<a href="#" class="btn btn-reinitialization" :class="[isCompleted ? '' : 'disabled']"
						@click="reset"> {{ $t("Button.reset") }}</a>

					<a href="#" class="btn btn-cancel" :class="[modified ? '' : 'disabled']"
						@click="reset_modified"> {{ $t("Button.modifications") }} </a>

					<div class="modificationLabel"> {{ this.modification_mute }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ValidStep from "../ui/buttons/ValidStepSpeech";
import throbber from "../ui/throbber";
import progressbar from "../ui/progressbar";
import lottie_error from "@/components/ui/lottie_error";
import axios from "axios";
import {EventBus} from "../../event/event-bus";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Speech",
	components: {
		ValidStep,
		throbber,
		progressbar,
		lottie_error,
	},
	props: {
		helpState: {
			type: Boolean,
			required: true,
		},
		id: Number,
		stepName: String,
		title: String,
		secondaryTitle: String,
		keywords: String,
		sourceLang: String,
		destLang: Array,
		stepIndex: Number,
		isVisible: Boolean,
		isCompleted: Boolean,
		video: Object,
		subtitles: Array,
		hasTitleField: Boolean,
		hasSecondaryTitleField: Boolean,
		hasKeywordsField: Boolean,
		hasVoiceOver: Boolean,
		groupId: String,
		renderId: String,
		projectId: Number,
		created_at: String,
		updated_at: String,
	},
	data() {
		return {
			base_url: process.env.VUE_APP_BASE_URL,
			results: [],
			text_error: "",
			valueTitle: "",
			videoName: "",
			isSaved: false,
			hasSubtitles: false,
			valueSecondaryTitle: "",
			valueKeywords: "",
			isMuted: false,
			hasMusicEnable: false,
			volume: 100,
			music_volume: 100,
			destinationLanguage: sessionStorage.getItem("dest_lang"),
			uploadedFiles: [],
			username: sessionStorage.getItem("username"),
			videos: [],
			videoUrl: "",
			modified: false,
			modification_mute: "",
			ready_for_edit: false,
			capture_ident: "",
			global_interval: null,
			preview_path: "",
			clip_path: "",
			base_path: "",
			step_mode: -1,
			upload_progress_value: 0,
			upload_progress_total: 1,
		};
	},
	computed: {
		inputValueTitle: {
			get() {
				return this.valueTitle;
			},
			set(v) {
				this.valueTitle = v;
			},
		},
		inputValueSecondaryTitle: {
			get() {
				return this.valueSecondaryTitle;
			},
			set(v) {
				this.valueSecondaryTitle = v;
			},
		},
		inputValueKeywords: {
			get() {
				return this.valueKeywords;
			},
			set(v) {
				this.valueKeywords = v;
			},
		},
		uploadedVideoFiles: {
			get() {
				return this.uploadedFiles;
			},
			set(v) {
				this.uploadedFiles = v;
			},
		},
	},
	beforeMount() {
		this.getDatas();
		this.capture_ident = this.b64EncodeUnicode(this.projectId + "|" + this.id + "|" + this.stepName)
		.replace(/\//g, "_").replace(/\+/g, "-").replace(/=+$/, "");
	},
	created() {
		let $this = this;
		EventBus.$on("setModified", bool => {
			if (bool) {
			}
			else {
				$this.modification_mute = "";
				this.modified = false;
				this.activate_upload = false;
			}
		});
		EventBus.$on("setStepSpeechComplete", id => {
			// $this.getDatas();
		});
		EventBus.$on("stepSpeechReload", id => {
			$this.getDatas();
		});
		EventBus.$on("isSaved", function (value) {
			if (value) {
				$this.isSaved = !value;
			}
		});
	},
	activated() {
		this.getDatas();

		if (this.hasCarouselVideos) {
			if (this.isCompleted) {
				this.step_mode = 1;
			}
			else {
				this.step_mode = 0;
			}
		}
		else {
			axios.get(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/query_base",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(response => {
				if (response.data.ready) {
					this.step_mode = 1;
					this.base_path = BASE_URL + "/public/storage/videos/generated/" + response.data.url;
				}
				else {
					this.step_mode = 0;
				}
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
				this.step_mode = 0;
			});
		}

	},
	deactivated() {
		clearInterval(this.global_interval);
		this.uploadedVideoFiles = [];
		this.$refs.fileUpload.value = "";
		this.$destroy();
	},
	methods: {
		b64EncodeUnicode(str) {
			// first we use encodeURIComponent to get percent-encoded UTF-8,
			// then we convert the percent encodings into raw bytes which
			// can be fed into btoa.
			return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
				function toSolidBytes(match, p1) {
					return String.fromCharCode("0x" + p1);
				}));
		},
		getDatas() {
			let $this = this;
			axios.get(BASE_URL + "/public/api/stepSpeeches/" + this.id, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(response => {
				let data = response.data.data;
				$this.isCompleted = data.isCompleted;
				$this.isMuted = data.isMuted;
				$this.hasMusicEnable = data.hasMusicEnable;
				this.volume = data.volume;
				this.music_volume = data.music_volume;

				if (data.secondaryTitle !== null) {
					$this.inputValueSecondaryTitle = data.secondaryTitle;
				}
				else {
					$this.inputValueSecondaryTitle = "";
				}
				if (data.title !== null) {
					$this.inputValueTitle = data.title;
				}
				else {
					$this.inputValueTitle = "";
				}

				// if (data.video !== undefined) {
				// 	$this.videoUrl = data.video.url;
				// 	this.has_video = true;
				// 	this.ready_for_edit = true;
				// }
				// else {
				// 	$this.videoUrl = "";
				// }

				$this.videos = JSON.parse(data.video_list);
				if ($this.videos.length > 0) {
					this.has_video = true;
					this.ready_for_edit = true;
				}

				if (data.keywords !== undefined) {
					if (data.keywords === "''") {
						data.keywords = "";
					}
					$this.inputValueKeywords = data.keywords;
				}
				else {
					$this.inputValueKeywords = "";
				}
				if (data.subtitles.length >= 1) {
					$this.hasSubtitles = true;
				}

				if (data.isCompleted) {
					EventBus.$emit("setStepSpeechComplete", $this.id);
				}
				else {
					EventBus.$emit("setStepSpeechNotComplete", $this.id);
				}
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});

			// axios.get(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/videos", {
			// 	headers: {
			// 		"Authorization": sessionStorage.getItem("auth"),
			// 	},
			// })
			// .then(response => {
			// 	console.log(response);
			// }).catch(error => {
			// 	this.text_error = this.$root.$t("Errors.message_project") + error;
			// 	this.$refs.modalError.show();
			// });
		},
		validate_video_selection() {
			axios.get(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/video_base",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				}).then(response => {
				this.step_mode = 1;
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		back_mode() {
			this.step_mode = 0;
		},
		move(index, change) {
			let new_order = new Array(this.videos.length).fill(undefined).map((_, i) => i);
			new_order[index] = index + change;
			new_order[index + change] = index;

			let bodyFormData = new FormData();
			bodyFormData.append("order", JSON.stringify(new_order));

			let new_values = [];
			for (let key of new_order) {
				new_values.push(this.videos[key]);
			}
			this.videos = new_values;

			let $this = this;
			axios.post(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/reorder",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				// $this.loadData();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});

			// reload
		},
		del_video(name, index) {
			console.log(name);
			let bodyFormData = new FormData();
			bodyFormData.append("value", name);
			this.$refs.loaderModal.show();
			let $this = this;
			axios.post(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/deletevideo",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.getDatas();
				$this.$refs.loaderModal.hide();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
		play_clip(filename) {
			console.log(filename);
			this.clip_path = BASE_URL + "/public/storage/videos/" + filename;
			this.$refs.clipModal.show();
		},
		play_base() {
			this.$refs.baseModal.show();
		},
		preview() {
			this.$refs.loaderModal.show();

			axios.get(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/preview",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				let data = response.data;

				this.$refs.loaderModal.hide();

				this.preview_path = BASE_URL + "/public/storage/videos/generated/" + data.url + "#" + new Date().getTime();
				this.$refs.previewModal.show();
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		reset() {
			this.$refs.loaderModal.show();

			axios.get(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/reset",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				this.$refs.loaderModal.hide();
				this.getDatas();
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		refresh_vid(id) {
			let $this = this;
			axios.get(BASE_URL + "/public/api/stepSpeeches/" + id,
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				let data = response.data.data;

				// if (data.video !== undefined && $this.videoUrl.substring(0, 5) !== "blob:" && data.video.url !== $this.videoUrl) {
				// 	$this.videoUrl = data.video.url;
				// 	this.ready_for_edit = true;
				// 	this.has_video = true;
				// }
				// Load video list instead


			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		synchronize() {
			let $this = this;
			this.$refs.loaderSubtitleModal.show();
			let bodyFormData = new FormData();
			if (this.username.length > 0) {
				bodyFormData.append("username", this.username);
			}
			axios.post(BASE_URL + "/public/api/recognize/" + this.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderSubtitleModal.hide();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
		showModal() {
			this.$refs.loaderSubtitleModal.show();
		},
		cut_video(file) {
			let file_param = file.split(".").slice(0, -1).join(".");
			this.$router.push({
				name: "VideoEdition2",
				params: {projectId: this.projectId, step_type: "s", stepId: this.id, filename: file_param},
			});
		},
		handleFileUpload() {
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepSpeech"});
			this.activate_upload = true;
			this.modified = true;
			this.has_video = true;
			this.ready_for_edit = false;
			let $this = this;
			let inputFiles = $this.$refs.fileUpload.files;
			this.isSaved = true;
			let player = $this.$refs.videoplayer;
			if (inputFiles.length >= 1) {
				for (let i = 0; i <= inputFiles.length - 1; i++) {
					let videoPath = URL.createObjectURL(inputFiles[i]);
					$this.videoUrl = videoPath;
					player.onloadedmetadata = function () {
						$this.uploadedFiles = [];
						$this.uploadedFiles.push({
							id: i,
							filename: inputFiles[i].name,
							file: inputFiles[i],
							video_duration: player.duration,
						});

						URL.revokeObjectURL(inputFiles[i]);
					};
				}
			}
			if ($this.uploadedVideoFiles.length > 1) {
				$this.uploadedVideoFiles.splice(0, 1);
			}
		},
		cancelUploadVideo() {
			let inputFiles = this.$refs.fileUpload.files;
			if (inputFiles[0]) {
				if (inputFiles[0].name !== this.videoName) {
					let player = this.$refs.videoplayer;
					player.src = this.videoUrl;
				}
			}
			this.$refs.fileUpload.value = "";
			this.isSaved = false;
		},
		upload_file() {
			let files = document.getElementById("input_newfile").files;

			if (!files.length) {
				return 0;
			}

			let bodyFormData = new FormData();
			bodyFormData.append("video", files[0]);

			this.$refs.loaderModal.show();
			let $this = this;
			axios.post(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/addvideo",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.getDatas();
				$this.$refs.loaderModal.hide();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
				$this.$refs.loaderModal.hide();
			});
		},
		async upload_files() {
			let files = document.getElementById("input_newfile").files;
			if (!files.length) {
				return 0;
			}

			this.upload_progress_total = files.length;
			this.upload_progress_value = 0;

			if (files.length > 1) {
				this.$refs.uploadModal.show();
			}
			else {
				this.$refs.loaderModal.show();
			}

			for (let file of files) {
				this.upload_progress_value += 1;

				let bodyFormData = new FormData();
				bodyFormData.append("video", file);

				let $this = this;
				await axios.post(BASE_URL + "/public/api/stepSpeeches/" + this.id + "/addvideo",
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Authorization": sessionStorage.getItem("auth"),
						},
					},
				).then(function () {
				})
				.catch(error => {
					$this.text_error = this.$root.$t("Errors.message_project") + error;
					$this.$refs.modalError.show();
					$this.$refs.uploadModal.hide();
					$this.$refs.loaderModal.hide();
					return false;
				});
			}

			this.getDatas();
			this.$refs.uploadModal.hide();
			this.$refs.loaderModal.hide();
		},
		goToEdition() {
			this.$destroy();
			this.$router.push({
				name: "SubtitleEdition",
				params: {
					projectId: this.projectId,
					step_type: "App\\StepSpeech",
					stepId: this.id,
					helpState: this.helpState,
				},
			});
		},
		goToCut() {
			if (this.videos.length > 0) {
				this.$router.push({
					name: "VideoEdition",
					params: {projectId: this.projectId, step_type: "App\\StepSpeech", stepId: this.id},
				});
			}
		},
		setModified() {
			this.modified = true;
			this.modification_mute = this.$root.$t("Button.editing");
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepSpeech"});
		},
		reset_modified() {
			this.getDatas();
			EventBus.$emit("unlock_steps", {id: this.id, type: "App\\StepSpeech"});
			this.modified = false;
			this.modification_mute = "";
			this.activate_upload = false;
		},
	},
};
</script>

<style scoped>
.title_label,
.function_label {
	font-size: 14px;
	color: #144B5E;
}

.btn {
	margin: 0;
	white-space: nowrap;
	border-radius: var(--small-border-radius);
}

[hidden] {
	display: none !important;
}

input[type=text] {
	border-radius: 0;
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #8AA0B2 solid 1px;
}

.btn-reinitialization {
	background-color: var(--color-cancel);
	border-color: var(--color-cancel);
	color: var(--text-cancel);
}

.btn-edition {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	cursor: pointer;
	color: var(--text-main-action);
}

.btn-cut {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
	cursor: pointer;
}

.btn-info {
	background-color: var(--color-secondary-action);
	border-color: var(--color-secondary-action);
	color: var(--text-secondary-action);
}

.btn-preview {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-secondary-action);
}

.btn-return {
	background-color: var(--color-secondary-action);
	border-color: var(--color-secondary-action);
	color: var(--text-secondary-action);
}

.btn-insert-voice {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
}

.btn-insert-voice:hover {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
}

.modificationLabel {
	font-size: 16px;
	color: var(--color-modification);
	padding: 7px 12px;
	display: block;
	line-height: 24px;
}

.btn-cancel {
	background-color: var(--color-modification);
	border-color: var(--color-modification);
	color: var(--text-modification);
}

.btn-validation {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
}

.embed-responsive {
	border: none;
	border-radius: var(--big-border-radius);
	box-shadow: 0 0 15px #00000033;
}

input.warning {
	color: red;
}

.video-list {
	list-style: none;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: stretch;
	gap: 15px;
	min-height: 120px;
	padding: 0;
	margin-bottom: 80px;
}

.video-info {
	display: flex;
	flex-direction: row;

	--width: 320px;
	--height: 180px;
}

.video-list .video-thumbnail {
	width: 160px;
	height: 90px;
	border-radius: var(--big-border-radius);
	border: 1px solid grey;
	box-sizing: border-box;
	position: relative;
	overflow: hidden;
	background-position: center;
	background-size: cover;
	user-select: none;
	z-index: 2;
}

.video-list .video-thumbnail button,
.video-list .menu {
	border: 0;
	position: absolute;
	visibility: hidden;

}

.video-list .video-block {
	position: relative;
}

.video-list .play-overlay {
	position: absolute;
	visibility: hidden;
	width: 160px;
	height: 90px;
	background: none;
	left: 0;
	top: 0;
	overflow: hidden;
	color: #FFFFFF80;
	cursor: default;
}

.video-list .play-overlay div {
	position: absolute;
	width: 60px;
	height: 70px;
	padding-left: 5px;
	left: 50%;
	top: 5px;
	transform: translateX(-50%);
	font-size: 70px;
	overflow: hidden;
	line-height: 70px;
	text-align: center;
	color: #FFFFFF80;
	cursor: pointer;
}

.video-list .video-block:hover .play-overlay,
.video-list .video-block:hover button,
.video-list .video-block:hover .menu {
	visibility: visible;
}

.video-list .video-thumbnail button.left {
	bottom: 0;
	left: 0;
	border-radius: 0 5px 0 0;
	padding: 5px 10px;
	line-height: 20px;
	font-size: 30px;
	background: #FFFFFF90;
}

.video-list .video-thumbnail button.right {
	bottom: 0;
	right: 0;
	border-radius: 5px 0 0 0;
	padding: 5px 10px;
	line-height: 20px;
	font-size: 30px;
	background: #FFFFFF90;
}

.video-info {
	display: flex;
	flex-direction: row;

	--width: 320px;
	--height: 180px;
}

.video-info .video-thumbnail {
	width: var(--width);
	height: var(--height);
	border-radius: var(--big-border-radius);
	border: 1px solid grey;
	box-sizing: border-box;
	position: relative;
	overflow: hidden;
	background-position: center;
	background-size: cover;
	user-select: none;
}

.video-info .play-overlay {
	border: 0;
	position: absolute;
	visibility: hidden;
	width: var(--width);
	height: var(--height);
	background: none;
	left: 0;
	top: 0;
	overflow: hidden;
	color: #FFFFFF80;
	cursor: default;
}

.video-info .play-overlay div {
	position: absolute;
	width: 60px;
	height: 70px;
	padding-left: 5px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 70px;
	overflow: hidden;
	line-height: 70px;
	text-align: center;
	color: #FFFFFF80;
	cursor: pointer;
}

.video-info div:hover .play-overlay,
.video-info div:hover button {
	visibility: visible;
}

.video-list .menu {
	z-index: 1;
	top: 0;
	margin: -5px;
	width: 170px;
	border-radius: calc(var(--big-border-radius) + 5px) calc(var(--big-border-radius) + 5px) calc(var(--small-border-radius) + 5px) calc(var(--small-border-radius) + 5px);
	background: #DDDDDD;
	padding: 100px 5px 5px;
	display: flex;
	flex-direction: column;
	gap: 5px;
}

#editor_grid {
	display: grid;
	grid-template-areas: "info info" "edition edition" "inputs audio" "validation validation";
	grid-auto-columns: 3fr 1fr;
	gap: 20px 40px;
}

#editor_grid .video-info {
	grid-area: info;
	height: var(--height);
	justify-content: center;
}

#editor_grid .edit-buttons {
	grid-area: edition;
	display: flex;
	justify-content: flex-start;
	gap: 10px;
}

#editor_grid .inputs {
	grid-area: inputs;
}

#editor_grid .audio {
	grid-area: audio;
}

#editor_grid .valid-buttons {
	grid-area: validation;
	display: flex;
	justify-content: flex-start;
	gap: 10px;
}

.button-bar {
	display: flex;
	gap: 10px;
}

</style>
